export default "__VITE_ASSET__D82nPq9Y__"